import { forwardRef, Ref } from 'react'
import cx from 'helpers/cx'

import StyledPageRow, { StyledPageRowProps } from 'js/page/Page/StyledPageRow'
import getTransparentColor from 'js/page/PageEditor/helpers/getTransparentColor'

import styles from './StyledPageEditorRow.module.css'

type Props = StyledPageRowProps & {
    $isFocused?: boolean
    $isDragging?: boolean
    className?: string
}

const StyledPageEditorRow = forwardRef(
    (
        { $isFocused, $isDragging, className, style, ...rest }: Props,
        ref: Ref<HTMLElement>,
    ) => {
        const transparentColor = getTransparentColor(
            rest.backgroundColor || '#f5f5f5',
        )

        return (
            <StyledPageRow
                ref={ref}
                {...rest}
                className={cx(
                    styles.row,
                    ($isFocused || $isDragging) && styles.isActiveShadow,
                    $isFocused && styles.isFocused,
                    className,
                )}
                style={
                    {
                        ...style,
                        '--editor-row-transparent-color': transparentColor,
                    } as React.CSSProperties
                }
            />
        )
    },
)

StyledPageEditorRow.displayName = 'StyledPageEditorRow'

export default StyledPageEditorRow
